import ColorStyles from '@Styles/colors.scss';
import React from 'react';
import { ICircleObjectProps } from '../PlanView';
import { getCoordinatesOfPointOnCircle } from '../helpers';

interface IEquipmentProps extends ICircleObjectProps {
    distanceFromCenter: number;
    strokeColor: string;
}

export const Equipment = (props: IEquipmentProps) => {
    const equipmentRadius = 4;

    const position = getCoordinatesOfPointOnCircle(
        props.distanceFromCenter,
        props.bearing,
        {
            x: props.circleCenter,
            y: props.circleCenter,
        }
    );

    const linePosition = getCoordinatesOfPointOnCircle(
        props.distanceFromCenter - equipmentRadius,
        props.bearing,
        {
            x: props.circleCenter,
            y: props.circleCenter,
        }
    );

    return (
        <svg>
            <line
                x1={props.circleCenter}
                y1={props.circleCenter}
                x2={linePosition.x}
                y2={linePosition.y}
                stroke={props.strokeColor}
            />
            <circle
                cx={position.x}
                cy={position.y}
                r={equipmentRadius}
                fill={ColorStyles.ikeGradient11}
                stroke={props.strokeColor}
                strokeWidth={1}
            />
        </svg>
    );
};
